<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!$parent.$parent.$parent.flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
        >
        <v-toolbar dark class="header-title">
          <v-toolbar-title class="title">{{
            $t("managementGPTModelNode")
          }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-top: 1rem">
            <v-col cols="3" class="mt-3">
              <v-text-field
                :label="$t('nodeName')"
                v-model="searchNodeName"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-btn fab class="primary white--text mt-3" @click="Search">
                <v-icon size="30">mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" justify="end" align="end">
              <v-btn
                class="primary white--text mt-3"
                style="margin-left: 1em"
                @click="Add()"
                >
                <v-icon size="20" style="padding-right: 5px;">mdi-plus-circle-outline</v-icon>
                {{ $t("add") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :items-per-page="itemsPerPage"
            :server-items-length="searchTotalTable"
            :options.sync="options"
            :items="menus"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center;">{{ item.number }}</td>
                <td>{{ item.nodeName }}</td>
                <td>{{ isSubstring(item.prompt) }}</td>
                <td style="text-align: center;">
                  <v-btn icon @click="Edit(item)">
                    <img alt="img-edit" :src="images.edit" />
                  </v-btn>
                </td>
                <td style="text-align: center;">
                  <v-btn icon @click="DeleteGroup(item.modelNodeID)">
                    <img alt="img-delete" :src="images.delete" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          {{ $t("loadingpleasewait") }}
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
import listPagingMixin from "@/mixins/listPagingMixin.js";
const LogTrace = checkPermissionTwo;
export default {
  name: "GPTModelNodeManagement",
  mixins: [checkPermissionTwo, LogTrace, listPagingMixin],
  data: () => ({
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    searchNodeName: "",
    isSearch: false,
    isFirst: true,
    menus: [
      {
        id: 0,
        MenuName: "User Management",
        Submenus: [
          { id: 11, SubmenuName: "Users" },
          { id: 22, SubmenuName: "User Group" },
          { id: 33, SubmenuName: "Permission Management" },
        ],
      },
      {
        id: 1,
        MenuName: "Menu Management",
      },
      {
        id: 2,
        MenuName: "Calendar",
      },
      {
        id: 3,
        MenuName: "Log",
      },
    ],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("no"), align: 'center', sortable: false, },
        { text: this.$t("modelName"), align: 'center', sortable: false, },
        { text: this.$t("prompt"), align: 'center', sortable: false, },
        { text: this.$t("edit"), align: 'center', sortable: false, },
        { text: this.$t("delete"), align: 'center', sortable: false, },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.Get();
    },
    Get() {
      this.GetList(
        (temp, ok, err) => call.GetTableGPTModelNode(temp, ok, err),
        { nodeName: this.searchNodeName },
        "menus"
      );
    },
    DeleteGroup(id) {
      try {
        let deleteconfirm = confirm(this.$t("confirmDeleteData"));
        if (deleteconfirm) {
          this.dialog = true;
          call.DeleteGPTModelNode(
            id,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.EditdialogUser = false;
                this.Get();
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          this.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      this.$router.push({
        name: "GPTModelInternalDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      this.$router.push({
        name: "GPTModelInternalDetail",
        query: {
          id: item.modelNodeID,
        },
      });
    },
    isSubstring: function (text = "") {
      if (text.length > 60) {
        return text.substring(0, 60) + "...";
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
